import { ProfileCollectPayload } from "@swivl-mono/types";
import parsePhoneNumberFromString from "libphonenumber-js";
import { postcodeValidator } from "postcode-validator";

const VarKey = {
  Email: "User:Email",
  PhoneNumber: "PhoneNumber",
  PostalCode: "User:PostalCode",
  FirstName: "FirstName",
};
export interface ProfileCollectValidationError {
  [field: string]: string;
}
export function ValidateProfileCollect(_payload: ProfileCollectPayload) {
  let validationErrors: ProfileCollectValidationError = {};
  let payload = { ..._payload };

  payload.items.forEach((item) => {
    if (item.required && (!item.value || item.value.length === 0)) {
      validationErrors[item.label] = "* required";
      return;
    } else if (!item.required && (!item.value || item.value.length === 0)) {
      return;
    }

    if (item.id === VarKey.Email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(String(item.value).toLowerCase())) {
        validationErrors[item.label] = "* invalid email";
      } else {
        item.value = item.value;
      }
    }

    if (item.id === VarKey.PhoneNumber || item.label === "Phone") {
      if (payload.countryCodes) {
        let isValid = false;
        payload.countryCodes.forEach((country) => {
          const parsedPhoneNumber = parsePhoneNumberFromString(item.value!, country as any);
          if (!parsedPhoneNumber || !parsedPhoneNumber.number || !parsedPhoneNumber.isValid()) {
          } else {
            isValid = true;

            if (parsedPhoneNumber.number !== item.value) {
              item.value = parsedPhoneNumber.number;
            }
          }
        });

        if (!isValid) {
          validationErrors[item.label] = "* invalid phone number";
        }
      } else {
        const parsedPhoneNumber = parsePhoneNumberFromString(item.value!, "US");
        if (!parsedPhoneNumber || !parsedPhoneNumber.number || !parsedPhoneNumber.isValid()) {
          validationErrors[item.label] = "* invalid phone number";
        } else {
          if (parsedPhoneNumber.number !== item.value) {
            item.value = parsedPhoneNumber.number;
          }
        }
      }
    }

    if (item.id === VarKey.PostalCode) {
      if (payload.countryCodes) {
        let isValid = false;
        payload.countryCodes.forEach((country) => {
          if (postcodeValidator(item.value!, country)) {
            isValid = true;
          }
        });
        if (!isValid) {
          validationErrors[item.label] = "* invalid code";
        }
      } else {
        if (!(postcodeValidator(item.value!, "US") || postcodeValidator(item.value!, "CA") || postcodeValidator(item.value!, "BB"))) {
          validationErrors[item.label] = "* invalid code";
        }
      }
    }

    if (item.id === "FirstName") {
      if (item.value!.length < 2) {
        validationErrors[item.label] = "* name must be at least 2 characters";
      }
    }
  });

  return { validationErrors, payload };
}
